// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li.item-menu-title {
  text-decoration: none;
  padding: 12px 28px;
  text-transform: uppercase;
  font-size: 0.875em;
  color: var(--ion-color-light-shade);
}
li.item-menu-title.mode-closed {
  display: none;
  background-color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/menu/item-title/item-title.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mCAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;AACJ","sourcesContent":["li.item-menu-title {\n  text-decoration: none;\n  padding: 12px 28px;\n  text-transform: uppercase;\n  font-size: 0.875em;\n  color: var(--ion-color-light-shade);\n\n  &.mode-closed {\n    display: none;\n    background-color: black;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
